import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';

function Marketing() {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const isMobile = size.height > size.width;
  const mainStyle = { textAlign: 'left' };

  const handleWindowSizeChange = () => setSize({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener('resize', handleWindowSizeChange);
    return () => window.removeEventListener('resize', handleWindowSizeChange);
  }, []);

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Paper className="paperFull" style={mainStyle}>
            <h1>Marketing</h1>
            <Paper style={mainStyle}>
              <h2>Les Outils</h2>
              <h3>CRM: Dolibarr</h3>
              Le CRM est disponible ici: <a href="http://syncstats.ddns.net/dolibarr/htdocs">syncstats.ddns.net/dolibarr/htdocs</a>
            </Paper>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Marketing;



// WEBPACK FOOTER //
// src/components/Marketing.js